import { render } from "./CreateMandat.vue?vue&type=template&id=7f3656e4&scoped=true"
import script from "./CreateMandat.vue?vue&type=script&lang=js"
export * from "./CreateMandat.vue?vue&type=script&lang=js"

import "./CreateMandat.vue?vue&type=style&index=0&id=7f3656e4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3656e4"]])

export default __exports__